import { BRAND } from '@onuw/roles-data'
import { Link } from 'react-router'
import { GUIDE_SLUGS } from '../content/guideSlugs'
import { GUIDES, type Guide } from '../content/guides'
import styles from '../content/guides/guides.module.css'
import { guidePath } from '../content/slugs'
import { AdSlot } from '../features/ads/AdSlot'
import { AD_SLOTS } from '../lib/config'
import { pageMeta } from '../lib/pageMeta'
import { Prose } from '../ui/Prose'

export function meta() {
  return pageMeta({
    title: 'Guides',
    description: `Guides to ${BRAND.name}: the night order, strategy, decks for every player count, marks and artifacts, hosting a game night, the bots, and what each expansion adds.`,
    path: '/guides',
  })
}

function Tiles({ group }: { group: Guide['group'] }) {
  return (
    <div className={styles.tiles}>
      {GUIDE_SLUGS.map((slug) => GUIDES[slug])
        .filter((g) => g.group === group)
        .map((g) => (
          <Link key={g.slug} to={guidePath(g.slug)} className={styles.tile}>
            <span className={styles.tileTitle}>{g.title}</span>
            <span className={styles.tileText}>{g.lead}</span>
          </Link>
        ))}
    </div>
  )
}

export default function GuidesPage() {
  return (
    <Prose title="Guides" lead="How the night works, how to win the day, and what every pack of roles adds.">
      <h2>Playing the game</h2>
      <Tiles group="play" />
      <h2>The packs of roles</h2>
      <Tiles group="pack" />
      <p>
        Looking for one card? <Link to="/roles/">Every role</Link> has a page of its own. New to the game?
        Start with <Link to="/rules/">how to play</Link>, and the{' '}
        <Link to="/faq/">questions and answers</Link>.
      </p>
      <AdSlot slot={AD_SLOTS.content} />
    </Prose>
  )
}
